if (!customElements.get('variant-info-bubble')) {
  customElements.define(
    'variant-info-bubble',
    class VariantInfoBubble extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.updateVisibility(event.data.variant);
        });

        this.initPopupToggle();
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      updateVisibility(variant) {
        const variantIds = (this.dataset.variantIds || '')
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean);

        // Empty setting means "show on every variant", matching the
        // server-rendered logic in snippets/variant-info-bubble.liquid.
        const shouldShow = variantIds.length === 0 || (variant && variantIds.includes(variant.id.toString()));

        this.toggleAttribute('hidden', !shouldShow);
      }

      // Scoped copy of assets/info-bubble.js's trigger/popup behavior.
      // Kept separate (rather than reused) since info-bubble.js selects its
      // elements with document.querySelector, which only ever wires up the
      // first bubble on the page.
      initPopupToggle() {
        const trigger = this.querySelector('.free-shipping-info-trigger');
        const popup = this.querySelector('.free-shipping-popup');
        const closeBtn = this.querySelector('.free-shipping-popup-close');

        if (!trigger || !popup || !closeBtn) return;

        trigger.addEventListener('click', (e) => {
          e.stopPropagation();
          popup.hidden = !popup.hidden;
        });

        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          popup.hidden = true;
        });

        document.addEventListener('click', (e) => {
          if (!popup.hidden && !popup.contains(e.target) && !trigger.contains(e.target)) {
            popup.hidden = true;
          }
        });

        popup.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }
    }
  );
}
